import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "../../../../../../utils/i18n.js";
const LicenseAllocationDisplay = ({ production, development, shouldHideEmpty = true })=>{
    const showProduction = !shouldHideEmpty || production > 0;
    const showDevelopment = !shouldHideEmpty || development > 0;
    if (!showProduction && !showDevelopment) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("span", {
        className: "rc-account-v2-license-alloc-display",
        children: [
            showProduction && /*#__PURE__*/ _jsxs("span", {
                className: "rc-account-v2-license-alloc-display__chip rc-account-v2-license-alloc-display__chip--production",
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: production
                    }),
                    production === 1 ? __("Production website") : __("Production websites")
                ]
            }),
            showDevelopment && /*#__PURE__*/ _jsxs("span", {
                className: "rc-account-v2-license-alloc-display__chip rc-account-v2-license-alloc-display__chip--development",
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: development
                    }),
                    development === 1 ? __("Development website") : __("Development websites")
                ]
            })
        ]
    });
};
export { LicenseAllocationDisplay };
